export const MEASUREMENT_DATES_ACCORDION_PANEL_LABELS = {
  addSubfolder: 'Add Subfolder',
  emptyDescription: 'Try a different company or measurement date.',
  emptyTitle: 'No documents available',
  errorDescription: 'Refresh the page, or try another company.',
  errorTitle: 'Could not load documents.',
  collapseMeasurementDate: (label: string) => `Collapse ${label}`,
  expandMeasurementDate: (label: string) => `Expand ${label}`,
  loadingRowCount: 6,
  measurementDateMetadata: ({
    documentCount,
    pendingRequestCount,
    sentRequestCount,
    subfolderCount,
    uploadedRequestCount,
  }: {
    documentCount: number;
    pendingRequestCount: number;
    sentRequestCount: number;
    subfolderCount: number;
    uploadedRequestCount: number;
  }) => `${documentCount} ${documentCount === 1 ? 'document' : 'documents'} | ${subfolderCount} ${
    subfolderCount === 1 ? 'subfolder' : 'subfolders'
  } | Requests: ${sentRequestCount} sent, ${uploadedRequestCount} uploaded, ${pendingRequestCount} pending`,
  placeholderDescription: 'Folders and documents for this measurement date will be added in the next Documents step.',
  selectMeasurementDateDocuments: (label: string) => `Select all documents in ${label}`,
  showMore: (count: number) => `Show ${count} more measurement dates`,
  showNewer: (count: number) => `Show ${count} more measurement dates`,
  uploadDocument: 'Upload Document',
  scrollHintItemSingular: 'measurement date',
  scrollHintItemPlural: 'measurement dates',
} as const;

export const MEASUREMENT_DATES_ACCORDION_PANEL_VISIBLE_INCREMENT = 10;
export const MEASUREMENT_DATES_ACCORDION_PANEL_ACTIVE_SCROLL_DELAY_MS = 120;

export const MEASUREMENT_DATES_ACCORDION_PANEL_NAVIGATION_ITEM_SELECTOR =
  '[data-measurement-dates-accordion-panel-item="true"]';

export const MEASUREMENT_DATES_ACCORDION_PANEL_SCROLL_ITEM_SELECTOR =
  '[data-measurement-dates-accordion-panel-scroll-item="true"]';
